import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { AccountService } from "@app-cmc/core/services/account.service";
import { combineLatest } from "rxjs";
import { filter, take } from "rxjs/operators";
@Component({
  template: ""
})
export class CallbackComponent implements OnInit {
  constructor(private router: Router, private accSvc: AccountService) {}

  ngOnInit() {
    const message = window.location.hash;
    if (window.parent && window.parent !== window) {
      // if loaded as an iframe during silent refresh
      window.parent.postMessage(message, location.origin);
    } else if (window.opener && window.opener !== window) {
      // if loaded as a popup during initial login
      window.opener.postMessage(message, location.origin);
    }

    combineLatest([
      this.accSvc.userChanged$.pipe(filter((v) => !!v)),
      this.router.events.pipe(filter((event) => event instanceof NavigationEnd))
    ])
      .pipe(take(1))
      .subscribe(() => {
        if (this.accSvc.isLoggedIn) {
          this.router.navigate(["/"]);
        }
      });
  }
}
